import { useContext, useRef } from "react"
import { UserContext } from "../context/userContext"
import { FirebaseContext } from "../firebase"
import { Menu } from "primereact/menu"
import { Button } from "primereact/button"
import { Link } from "react-router-dom"
import ROUTES from "../components/Routes/routesContants"
import { useNavigate } from "react-router-dom"

//styles
import styles from "../styles/Layout.module.css"

//assets
import Notifications from "../components/notifications/notifications"
// import DeveloperTools from "../components/DeveloperTools/DeveloperTools"
import ProfilePhoto from "../components/ProfilePhoto"
import { LoaderSmall } from "../components/Loaders"
import Tasks from "../components/Tasks/Tasks"
import Appointments from "../components/Appointments/Appointments"

export default function Header() {
  const userCtx = useContext(UserContext)
  const firebase = useContext(FirebaseContext)
  const menuRight = useRef(null)
  const navigate = useNavigate()

  const menuItems = [
    {
      template: () => {
        return (
          <div
            style={{
              display: "flex",
              gap: "5px",
              alignItems: "center",
              padding: "0.5rem 1rem",
            }}
          >
            <span>
              {userCtx.participant_name_first} {userCtx.participant_name_last}
            </span>
          </div>
        )
      },
    },
    {
      template: () => <div className={styles.menu_divider} />,
    },
    {
      template: () => (
        <div className={styles.menu_preferences}>
          <div className={styles.menu_preferences_header}>
            <i className="pi pi-cog"></i>
            <span>Preferences</span>
          </div>
          <div className={styles.menu_preferences_links}>
            <button
              className={styles.menu_preferences_link}
              onClick={(e) => {
                navigate(ROUTES.PREFERENCES_ACCOUNT)
                menuRight.current.hide(e.currentTarget);
              }}
            >
              Account
            </button>
            <button
              className={styles.menu_preferences_link}
              onClick={(e) => {
                navigate(ROUTES.PREFERENCES_PROFILE)
                menuRight.current.hide(e.currentTarget);
              }}
            >
              Profile
            </button>
            <button
              className={styles.menu_preferences_link}
              onClick={(e) => {
                navigate(ROUTES.PREFERENCES_NOTIFICATIONS)
                menuRight.current.hide(e.currentTarget);
              }}
            >
              Notifications
            </button>
          </div>
        </div>
      ),
    },
    {
      label: "Support",
      icon: "pi pi-question-circle",
      url: "https://help.myrecoverylink.com/",
      target: "_blank",
    },
    {
      label: "Log Out",
      icon: "pi pi-sign-out",
      command: () => {
        sessionStorage.clear()
        navigate(ROUTES.HOMEPAGE)
        firebase.signOut()
      },
    },
  ]

  return (
    <header>
      <div className="grid py-3 px-1">
        <div className="col-1">
          <Link to="/">
            <div className={styles.logo_container}></div>
          </Link>
        </div>
        <div className="col-11 flex flex-row flex-wrap justify-content-end align-items-center py-3">
          <ul className="flex flex-row flex-wrap gap-3">
            {/* <DeveloperTools /> */}
            <Tasks />
            <Notifications />
            <Appointments />
            <li className="top_icon ml-3">
              <Menu
                model={menuItems}
                popup
                ref={menuRight}
                className="header-menu"
                popupAlignment="right"
              />
              <Button
                className={styles.menu_button}
                onClick={(event) => {
                  event.current = event
                  menuRight.current.toggle(event)
                }}
              >
                {userCtx.loadingParticipantData ? (
                  <LoaderSmall />
                ) : (
                  <>
                    <ProfilePhoto />
                    <div className="summary">
                      <span>
                        {`${userCtx.participant_name_first} ${userCtx.participant_name_last}`}
                      </span>
                    </div>
                  </>
                )}
              </Button>
              <Button
                className={`${styles.menu_icon_button} p-button-text`}
                icon="pi pi-bars"
                onClick={(event) => {
                  event.current = event
                  menuRight.current.toggle(event)
                }}
              />
            </li>
          </ul>
        </div>
      </div>
    </header>
  )
}
